// @flow
export const SET_UI_STATE = 'SET_UI_STATE'

export const containerIds = {
  HOME: 'HOME',
  GUIDE: 'GUIDE',
  GUIDE_LIST: 'GUIDE_LIST',
  SPACE: 'SPACE',
  ROOM: 'ROOM',
  SEARCH: 'SEARCH',
  HEADER: 'HEADER',
  FAVORITE: 'FAVORITE',
  RESERVATION_DETAIL: 'RESERVATION_DETAIL',
  TWEET_CAMPAIGN: 'TWEET_CAMPAIGN',
}

/**
 * Reducer section
 */
const initialState = {
  selectFavoriteListItemModal: {
    isOpen: false,
    roomId: null,
  },
  deleteFavoriteListItemModal: {
    isOpen: false,
    roomId: null,
  },
}

// FlowType
type Action = {
  type: string,
  containerId: string,
  payload: any,
}

export function reducer(state: Object = initialState, action: Action) {
  switch (action.type) {
    case SET_UI_STATE:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export function setUIState(containerId: string, payload: Object): Object {
  if (Object.keys(containerIds).indexOf(containerId) !== -1) {
    return {
      type: SET_UI_STATE,
      containerId,
      payload,
    }
  }
  return {}
}



// WEBPACK FOOTER //
// ./src/redux/modules/ui.js